export function FormStatusMessage({ message }) {
  if (!message) return null;

  return (
    <p role="alert" className="rounded-md border border-redline/30 bg-redline/5 px-4 py-3 text-sm font-medium text-redline">
      {message}
    </p>
  );
}